import 'focus-visible';
import React__default from 'react';
import { ThemeProvider } from 'styled-components';
import 'react-toastify';
import './components/Box/index.js';
import './components/CloseButton/index.js';
import './components/Loading/index.js';
import './components/Text/index.js';
import { ToastContainer } from './components/Toast/ToastContainer.js';
import GlobalStyles from './GlobalStyles.js';
import { getProviderThemeProps } from './themes/getProviderThemeProps.js';

const BlockPartyProvider = _ref => {
  let {
    theme = 'Endpoint',
    children
  } = _ref;
  const getTheme = () => {
    if (typeof theme === 'string') {
      return getProviderThemeProps(theme);
    }
    return theme;
  };
  return /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: getTheme()
  }, /*#__PURE__*/React__default.createElement(GlobalStyles, null), children, /*#__PURE__*/React__default.createElement(ToastContainer, null));
};

export { BlockPartyProvider as default };
